import { useParams, Link } from 'react-router-dom';
import { Seo, SITE_URL } from '../components/Seo';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { ArticleBody, ArticleMeta, Disclaimer, ArticleCard } from '../components/ArticleParts';
import { knowledgeArticles } from '../content/knowledge';
import NotFound from './NotFound';

export default function WissenArtikel() {
  const { slug } = useParams();
  const article = knowledgeArticles.find((a) => a.slug === slug);
  if (!article) return <NotFound />;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.metaDescription,
    author: { '@type': 'Organization', name: 'Felix Genuss Redaktion', url: SITE_URL },
    publisher: { '@id': `${SITE_URL}/#organization` },
    datePublished: article.veroeffentlicht,
    dateModified: article.geaendert,
    inLanguage: 'de',
    mainEntityOfPage: `${SITE_URL}/wissen/${article.slug}`,
  };

  const others = knowledgeArticles.filter((a) => a.slug !== slug).slice(0, 2);

  return (
    <>
      <Seo title={article.seoTitle} description={article.metaDescription} path={`/wissen/${article.slug}`} jsonLd={jsonLd} />
      <Breadcrumbs items={[{ label: 'Startseite', href: '/' }, { label: 'Wissen', href: '/wissen' }, { label: article.title }]} />

      <article className="container-site mt-10 max-w-3xl" data-testid="wissen-artikel">
        <p className="eyebrow">{article.kategorie}</p>
        <h1 className="mt-3 font-serif text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">{article.title}</h1>
        <ArticleMeta article={article} />
        <p className="mt-6 text-lg leading-relaxed text-brand-brown/85">{article.teaser}</p>
        <hr className="gold-rule mt-8" />
        <div className="mt-10">
          <ArticleBody article={article} />
        </div>
        <Disclaimer />
        <p className="mt-10 text-sm leading-relaxed text-brand-brown-soft">
          Passend dazu: unsere{' '}
          <Link to="/rezepte" className="link-inline">Rezepte für anspruchsvolle Hunde</Link>.
        </p>
      </article>

      <aside className="container-site mt-16" aria-labelledby="weiterlesen-heading">
        <h2 id="weiterlesen-heading" className="font-serif text-2xl font-bold sm:text-3xl">Weiterlesen</h2>
        <div className="mt-8 grid gap-6 sm:grid-cols-2">
          {others.map((a) => (
            <ArticleCard key={a.slug} article={a} basePath="/wissen" />
          ))}
        </div>
      </aside>
    </>
  );
}
